import { TmApiClientError } from '@/core/error/transport/tmApiClientError'

export class TmApiAuthentificationSessionExpiredError extends TmApiClientError {
  public name = 'TmApiAuthentificationSessionExpiredError'
}
